export default "__VITE_ASSET__BZGsIYRK__"